import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../components/ui/SectionHeader";
import { pricing } from "../data/siteData";
import { fetchPricing } from "../services/publicApi";

const fallbackPricing = pricing.map(([title, priceLabel], index) => ({
  id: title,
  title,
  priceLabel,
  sortOrder: index,
}));

function PricingPage() {
  const [items, setItems] = useState(fallbackPricing);
  const [status, setStatus] = useState("");

  useEffect(() => {
    let mounted = true;

    async function loadPricing() {
      try {
        const response = await fetchPricing();
        if (!mounted) return;
        const apiItems = response?.items || [];
        if (apiItems.length) {
          setItems(apiItems);
          setStatus("");
        }
      } catch (error) {
        if (!mounted) return;
        setStatus("Cenik se ted nepodarilo nacist z API, zobrazuji orientacni ceny.");
      }
    }

    loadPricing();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Cenik" title="Orientacni ceny">
          Finalni cena zalezi na rozsahu, pristupu k trasam a materialu. Cilem je mit zakladni predstavu pred nabidkou.
        </SectionHeader>

        {status && (
          <div className="mt-6 rounded-md border border-cyan-300/20 bg-cyan-300/10 p-4 text-sm text-cyan-100">
            {status}
          </div>
        )}

        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
          <div className="card overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[620px] text-left text-sm">
                <thead className="bg-cyan-300/5 text-xs uppercase tracking-wide text-slate-400">
                  <tr>
                    <th className="px-5 py-3">Polozka</th>
                    <th className="px-5 py-3">Cena</th>
                    <th className="px-5 py-3">Poznamka</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-cyan-300/10">
                  {items.map((item) => (
                    <tr key={item.id || item.title}>
                      <td className="px-5 py-4 font-medium text-slate-200">{item.title}</td>
                      <td className="px-5 py-4 font-semibold text-white">{item.priceLabel}</td>
                      <td className="px-5 py-4 text-slate-400">{item.note || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <aside className="card p-6">
            <h2 className="text-xl font-bold text-white">Jak se cena potvrzuje</h2>
            <p className="mt-4 text-sm leading-6 text-slate-300">
              Po poptavce prijde kratka konzultace, pripadne prohlidka. Pak vznikne nabidka s jasnym rozsahem.
            </p>
            <Link to="/kontakt" className="mt-6 btn-primary w-full">
              Poptat cenu
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default PricingPage;
